import React from 'react';
import styled from 'styled-components';

const ErrorCard = ({ errorMessage, onClose }) => {
  return (
    <StyledWrapper>
      <div className="error">
        <div className="error__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
          </svg>
        </div>
        <div className="error__message">
          <p>{errorMessage}</p>
        </div>
        <div
          className="error__close"
          onClick={onClose}
          role="button"
          aria-label="Close error message"
        >
          ×
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .error {
    background: rgb(221, 223, 235);
    padding: 12px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    margin: 10px 0;
  }

  .error__icon {
    margin-right: 8px;
  }

  .error__message {
    font-size: 12px;
    color: rgb(17, 9, 10);
    flex-grow: 1;
  }

  .error__close {
    margin-left: auto;
    cursor: pointer;
    color: rgb(32, 10, 12);
    font-weight: bold;
    font-size: 16px;
    padding: 0 8px;
    transition: color 0.2s ease;

    &:hover {
      color: #ff0000;
    }
  }
`;

export default ErrorCard;